import styled from "styled-components";
import { ClassCarousel } from "ui/base/class/ClassCarousel";
import { userRoute } from "../../user.routes";
import { useNavigate } from "react-router-dom";
import { useAuth } from "context/AuthContext";

const OPTIONS = { align: "start" };
const SLIDES = Array.from({ length: 10 });

export const SimilarClasses = ({ similarClasses }) => {
  const { userData } = useAuth();
  const navigate = useNavigate();

  const classes = similarClasses?.filter((item) => item.user?.id !== userData?.id);

  return (
    <Container>
      <ClassCarousel
        title="Other classes"
        slides={classes || SLIDES}
        options={OPTIONS}
        narrowTitleContainer
        onSlideClick={(id) => navigate(userRoute.classDetail + id)}
      />
    </Container>
  );
};

const Container = styled.div`
  width: 100%;
`;
